import img1 from '../../assets/caseStudy/hamidah_sempurna.png';
import img5 from '../../assets/caseStudy/perumahan_tauhid.png';
import img2 from '../../assets/caseStudy/danar_mas.jpg';
import img3 from '../../assets/caseStudy/feng_tey.jpg';
import img4 from '../../assets/caseStudy/internasional_niaga.png';
import img6 from '../../assets/caseStudy/muhammadiyah_bandung.png';

const fakeData = [
    {
        id: 1,
        designation: 'Perumahan',
        title: 'Lembur Tauhid Madani',
        img: img5,
        category: 'perumahan'
    },
    {
        id: 2,
        designation: 'Corporate',
        title: 'PT Internasional Niaga Globalindo',
        img: img4,
        category: 'corporate'
    },
    {
        id: 3,
        designation: 'Corporate',
        title: 'PT Feng Tey Indonesia',
        img: img3,
        category: 'corporate'
    },
    {
        id: 4,
        designation: 'Corporate',
        title: 'Danar Mas',
        img: img2,
        category: 'corporate'
    },
    {
        id: 5,
        designation: 'Sekolah',
        title: 'Sekolah Hamidah Sampurna',
        img: img1,
        category: 'sekolah'
    },
    {
        id: 6,
        designation: 'Rumah Sakit',
        title: 'Rumah Sakit Muhammadiyah Bandung Selatan',
        img: img6,
        category: 'rumah sakit'
    }
]
export default fakeData;